import React, {Fragment, useState} from 'react'
import {currentLang} from './../../../utils/functions';
import {siteInfo} from './../../../utils/config';
import {truncate} from 'lodash';

const SchemaRecipe = ({data}) => {
    return (
        <div itemtype="http://schema.org/Recipe" itemscope>
            <meta itemprop="name" content={data.title+" | "+siteInfo[currentLang()]['title']}/>
            <link itemprop="image" href={data.image_url} /> 
            <meta itemprop="description" content={truncate(data.body, {'length':150})}/> 
            <meta itemprop="prepTime" content={data.shop_package_price} /> 
            <meta itemprop="cookTime" content={data.shop_package_price} /> 
            <meta itemprop="author" type="Person" content={data.author} /> 
            <meta itemprop="calories" content={data.calories} /> 
            <meta itemprop="recipeYield" content={data.portion_amount} /> 
        </div>
    )
}

export default SchemaRecipe
